import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription, of as observableOf } from 'rxjs';
import { catchError, take } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';

import { EntryService } from '../../tamalelibs/services/entry.service';
import { StoreQuerierService } from '../../services/store-querier.service';

@Component({
    selector: 'tam-file-download',
    template: '<div></div>'
})
export class FileDownloadComponent implements OnInit, OnDestroy {

    private _destroySubscriptions: Subscription = new Subscription();

    constructor(
        private _router: ActivatedRoute,
        private _entryService: EntryService,
        private _storeService: StoreQuerierService
    ) { }

    ngOnInit() {
        const fileId: string = this._router.snapshot.params['fileid'];
        const user = this._storeService.getCurrentUser();

        this._destroySubscriptions = this._entryService.getEntryById(fileId).pipe(
            take(1),
            catchError(() => {
                return observableOf();
            })).subscribe(() => {
                const fileUrl = `/restapi/2.1/entry/${fileId}/filedata/${fileId}?userid=${user.id}`;
                window.location.href = fileUrl;
            });
    }

    ngOnDestroy() {
        this._destroySubscriptions.unsubscribe();
    }
}
